import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: ", ";\n  ", "\n\n  width: 4px;\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { position as cssPosition } from 'polished';
import { color } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';

function getHighlighterPosition(pos) {
  switch (pos) {
    case 'left':
      return cssPosition('absolute', '0', null, '0', '0');

    case 'right':
      return cssPosition('absolute', '0', '0', '0', null);

    default:
      return null;
  }
}

var HighlighterBase = styled.div(_templateObject());
var Highlight = styled.div(_templateObject2(), function (props) {
  return props.customColor || color.highlight;
}, function (props) {
  return props.enabled ? 'flex' : 'none';
}, function (props) {
  return getHighlighterPosition(props.position);
});
/**
 * This component adds a highlight to other components
 *
 * @example ./__docs__/Highlighter.md
 */

export var Highlighter = function Highlighter(_a) {
  var children = _a.children,
      _a$enabled = _a.enabled,
      enabled = _a$enabled === void 0 ? false : _a$enabled,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'right' : _a$position,
      rounded = _a.rounded,
      otherProps = __rest(_a, ["children", "enabled", "position", "rounded"]);

  return React.createElement(HighlighterBase, null, React.createElement(Highlight, Object.assign({
    rounded: rounded,
    enabled: enabled,
    position: position,
    "data-e2e": getE2eLabel('highlight')
  }, otherProps)), children);
};